import {
  FETCH_PIPE_MILL_REPORTS,
  FETCH_PIPE_MILL_REPORTS_SUCCESS,
  FETCH_PIPE_MILL_REPORTS_FAILURE,
  FETCH_PIPE_MILL_MOCK_DATA,
  FETCH_PIPE_MILL_MOCK_DATA_SUCCESS,
  FETCH_PIPE_MILL_MOCK_DATA_FAILURE,
  FETCH_PIPE_MILL_REPORT_METADATA,
  FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS,
  FETCH_PIPE_MILL_REPORT_METADATA_FAILURE,
  SAVE_PIPE_MILL_REPORT,
  SAVE_PIPE_MILL_REPORT_SUCCESS,
  SAVE_PIPE_MILL_REPORT_FAILURE,
  SAVE_BULK_PIPE_MILL_REPORTS,
  SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS,
  SAVE_BULK_PIPE_MILL_REPORTS_FAILURE,
  SAVE_PIPE_MILL_REPORT_ITEM,
  SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS,
  SAVE_PIPE_MILL_REPORT_ITEM_FAILURE,
  SAVE_PIPE_MILL_REPORT_STATUS,
  SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS,
  SAVE_PIPE_MILL_REPORT_STATUS_FAILURE,
  DELETE_PIPE_MILL_REPORT,
  DELETE_PIPE_MILL_REPORT_SUCCESS,
  DELETE_PIPE_MILL_REPORT_FAILURE,
  DELETE_PIPE_MILL_REPORT_ITEM,
  DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS,
  DELETE_PIPE_MILL_REPORT_ITEM_FAILURE,
  EVALUATE_PIPE_MILL_REPORT,
  EVALUATE_PIPE_MILL_REPORT_SUCCESS,
  EVALUATE_PIPE_MILL_REPORT_FAILURE,
  FETCH_PIPE_MILL_PROJECT_LIMITS,
  FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS,
  FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE,
  SAVE_PIPE_MILL_PROJECT_LIMIT,
  SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS,
  SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE,
  DELETE_PIPE_MILL_PROJECT_LIMIT,
  DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS,
  DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE,
  FETCH_PIPE_MILL_FREQUENCY_RULES,
  FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS,
  FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE,
  SAVE_PIPE_MILL_FREQUENCY_RULE,
  SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS,
  SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE,
  DELETE_PIPE_MILL_FREQUENCY_RULE,
  DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS,
  DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE,
  FETCH_PIPE_MILL_CLEARANCE_STATUS,
  FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS,
  FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE,
  CLEAR_PIPE_MILL_REPORT_SAVE_STATUS,
  CLEAR_PIPE_MILL_REPORT_ERRORS,
} from './types';

const initialState = {
  reports: [],
  reportsLoading: false,
  reportsError: null,

  mockData: null,
  mockDataLoading: false,
  mockDataError: null,

  metadataByType: {},
  metadataLoadingByType: {},
  metadataErrorByType: {},

  projectLimits: [],
  projectLimitsLoading: false,
  projectLimitsError: null,

  frequencyRules: [],
  frequencyRulesLoading: false,
  frequencyRulesError: null,

  clearanceStatus: null,
  clearanceStatusLoading: false,
  clearanceStatusError: null,

  saving: false,
  savingScope: null,
  saveError: null,
  saveSuccess: false,
  lastSaved: null,

  evaluating: false,
  evaluateError: null,
  lastEvaluated: null,
};

const errorMessage = (error, fallback) => error?.message || String(error || fallback);

const getEntityId = (entity, keys) => {
  for (const key of keys) {
    if (entity?.[key] !== undefined && entity?.[key] !== null) return entity[key];
  }
  return undefined;
};

const upsertByKeys = (list, entity, keys) => {
  if (!entity) return list;
  const nextId = getEntityId(entity, keys);
  if (nextId === undefined) return [entity, ...list];
  const exists = list.some((item) => getEntityId(item, keys) === nextId);
  if (!exists) return [entity, ...list];
  return list.map((item) => (getEntityId(item, keys) === nextId ? entity : item));
};

const removeByKeys = (list, entity, keys) => {
  const removeId = getEntityId(entity, keys);
  if (removeId === undefined) return list;
  return list.filter((item) => getEntityId(item, keys) !== removeId);
};

const metadataType = (entity) => entity?.reportType || entity?.report_type;

const metadataListToMap = (payload) => {
  const list = Array.isArray(payload) ? payload : payload ? [payload] : [];
  return list.reduce((acc, item) => {
    const reportType = metadataType(item);
    return reportType ? { ...acc, [reportType]: item } : acc;
  }, {});
};

export default function pipeMillReportReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PIPE_MILL_REPORTS:
      return { ...state, reportsLoading: true, reportsError: null };
    case FETCH_PIPE_MILL_REPORTS_SUCCESS:
      return { ...state, reportsLoading: false, reportsError: null, reports: Array.isArray(action.payload) ? action.payload : [] };
    case FETCH_PIPE_MILL_REPORTS_FAILURE:
      return { ...state, reportsLoading: false, reportsError: errorMessage(action.error, 'Failed to load pipe mill reports') };

    case FETCH_PIPE_MILL_MOCK_DATA:
      return { ...state, mockDataLoading: true, mockDataError: null };
    case FETCH_PIPE_MILL_MOCK_DATA_SUCCESS:
      return { ...state, mockDataLoading: false, mockDataError: null, mockData: action.payload || null };
    case FETCH_PIPE_MILL_MOCK_DATA_FAILURE:
      return { ...state, mockDataLoading: false, mockDataError: errorMessage(action.error, 'Failed to load pipe mill mock data') };

    case FETCH_PIPE_MILL_REPORT_METADATA: {
      const reportType = action.payload?.reportType || 'UNKNOWN';
      return {
        ...state,
        metadataLoadingByType: { ...state.metadataLoadingByType, [reportType]: true },
        metadataErrorByType: { ...state.metadataErrorByType, [reportType]: null },
      };
    }
    case FETCH_PIPE_MILL_REPORT_METADATA_SUCCESS: {
      if (Array.isArray(action.payload)) {
        return {
          ...state,
          metadataByType: { ...state.metadataByType, ...metadataListToMap(action.payload) },
          metadataLoadingByType: {},
          metadataErrorByType: {},
        };
      }
      const reportType = action.payload?.reportType || action.meta?.reportType || 'UNKNOWN';
      return {
        ...state,
        metadataByType: { ...state.metadataByType, [reportType]: action.payload },
        metadataLoadingByType: { ...state.metadataLoadingByType, [reportType]: false },
        metadataErrorByType: { ...state.metadataErrorByType, [reportType]: null },
      };
    }
    case FETCH_PIPE_MILL_REPORT_METADATA_FAILURE: {
      const reportType = action.meta?.reportType || 'UNKNOWN';
      return {
        ...state,
        metadataLoadingByType: { ...state.metadataLoadingByType, [reportType]: false },
        metadataErrorByType: { ...state.metadataErrorByType, [reportType]: errorMessage(action.error, 'Failed to load metadata') },
      };
    }

    case FETCH_PIPE_MILL_PROJECT_LIMITS:
      return { ...state, projectLimitsLoading: true, projectLimitsError: null };
    case FETCH_PIPE_MILL_PROJECT_LIMITS_SUCCESS:
      return { ...state, projectLimitsLoading: false, projectLimitsError: null, projectLimits: Array.isArray(action.payload) ? action.payload : [] };
    case FETCH_PIPE_MILL_PROJECT_LIMITS_FAILURE:
      return { ...state, projectLimitsLoading: false, projectLimitsError: errorMessage(action.error, 'Failed to load project limits') };

    case FETCH_PIPE_MILL_FREQUENCY_RULES:
      return { ...state, frequencyRulesLoading: true, frequencyRulesError: null };
    case FETCH_PIPE_MILL_FREQUENCY_RULES_SUCCESS:
      return { ...state, frequencyRulesLoading: false, frequencyRulesError: null, frequencyRules: Array.isArray(action.payload) ? action.payload : [] };
    case FETCH_PIPE_MILL_FREQUENCY_RULES_FAILURE:
      return { ...state, frequencyRulesLoading: false, frequencyRulesError: errorMessage(action.error, 'Failed to load frequency rules') };

    case FETCH_PIPE_MILL_CLEARANCE_STATUS:
      return { ...state, clearanceStatusLoading: true, clearanceStatusError: null };
    case FETCH_PIPE_MILL_CLEARANCE_STATUS_SUCCESS:
      return { ...state, clearanceStatusLoading: false, clearanceStatusError: null, clearanceStatus: action.payload || null };
    case FETCH_PIPE_MILL_CLEARANCE_STATUS_FAILURE:
      return { ...state, clearanceStatusLoading: false, clearanceStatusError: errorMessage(action.error, 'Failed to load clearance status') };

    case SAVE_PIPE_MILL_REPORT:
      return { ...state, saving: true, savingScope: 'report', saveError: null, saveSuccess: false };
    case SAVE_PIPE_MILL_REPORT_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'report', at: Date.now(), response: action.payload },
        reports: upsertByKeys(state.reports, action.payload, ['reportId', 'id']),
        metadataByType: { ...state.metadataByType, ...metadataListToMap(action.payload) },
      };
    case SAVE_PIPE_MILL_REPORT_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save report'), saveSuccess: false };

    case SAVE_BULK_PIPE_MILL_REPORTS:
      return { ...state, saving: true, savingScope: 'bulkReports', saveError: null, saveSuccess: false };
    case SAVE_BULK_PIPE_MILL_REPORTS_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'bulkReports', at: Date.now(), response: action.payload },
        reports: Array.isArray(action.payload?.reports) ? action.payload.reports : state.reports,
        metadataByType: { ...state.metadataByType, ...metadataListToMap(action.payload?.metadata || []) },
      };
    case SAVE_BULK_PIPE_MILL_REPORTS_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save reports'), saveSuccess: false };

    case SAVE_PIPE_MILL_REPORT_ITEM:
      return { ...state, saving: true, savingScope: 'reportItem', saveError: null, saveSuccess: false };
    case SAVE_PIPE_MILL_REPORT_ITEM_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'reportItem', at: Date.now(), response: action.payload },
        reports: upsertByKeys(state.reports, action.payload, ['reportId', 'id']),
      };
    case SAVE_PIPE_MILL_REPORT_ITEM_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save report item'), saveSuccess: false };

    case SAVE_PIPE_MILL_REPORT_STATUS:
      return { ...state, saving: true, savingScope: 'reportStatus', saveError: null, saveSuccess: false };
    case SAVE_PIPE_MILL_REPORT_STATUS_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'reportStatus', at: Date.now(), response: action.payload },
        reports: upsertByKeys(state.reports, action.payload, ['reportId', 'id']),
      };
    case SAVE_PIPE_MILL_REPORT_STATUS_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save report status'), saveSuccess: false };

    case DELETE_PIPE_MILL_REPORT:
      return { ...state, saving: true, savingScope: 'reportDelete', saveError: null, saveSuccess: false };
    case DELETE_PIPE_MILL_REPORT_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        reports: removeByKeys(state.reports, action.payload, ['reportId', 'id']),
      };
    case DELETE_PIPE_MILL_REPORT_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to delete report'), saveSuccess: false };

    case DELETE_PIPE_MILL_REPORT_ITEM:
      return { ...state, saving: true, savingScope: 'reportItemDelete', saveError: null, saveSuccess: false };
    case DELETE_PIPE_MILL_REPORT_ITEM_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        reports: upsertByKeys(state.reports, action.payload, ['reportId', 'id']),
      };
    case DELETE_PIPE_MILL_REPORT_ITEM_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to delete report item'), saveSuccess: false };

    case EVALUATE_PIPE_MILL_REPORT:
      return { ...state, evaluating: true, evaluateError: null };
    case EVALUATE_PIPE_MILL_REPORT_SUCCESS:
      return {
        ...state,
        evaluating: false,
        evaluateError: null,
        lastEvaluated: action.payload || null,
        reports: upsertByKeys(state.reports, action.payload, ['reportId', 'id']),
      };
    case EVALUATE_PIPE_MILL_REPORT_FAILURE:
      return { ...state, evaluating: false, evaluateError: errorMessage(action.error, 'Failed to evaluate report') };

    case SAVE_PIPE_MILL_PROJECT_LIMIT:
      return { ...state, saving: true, savingScope: 'projectLimit', saveError: null, saveSuccess: false };
    case SAVE_PIPE_MILL_PROJECT_LIMIT_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'projectLimit', at: Date.now(), response: action.payload },
        projectLimits: upsertByKeys(state.projectLimits, action.payload, ['limitId', 'id']),
      };
    case SAVE_PIPE_MILL_PROJECT_LIMIT_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save project limit'), saveSuccess: false };
    case DELETE_PIPE_MILL_PROJECT_LIMIT:
      return { ...state, saving: true, savingScope: 'projectLimitDelete', saveError: null, saveSuccess: false };
    case DELETE_PIPE_MILL_PROJECT_LIMIT_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        projectLimits: removeByKeys(state.projectLimits, action.payload, ['limitId', 'id']),
      };
    case DELETE_PIPE_MILL_PROJECT_LIMIT_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to delete project limit'), saveSuccess: false };

    case SAVE_PIPE_MILL_FREQUENCY_RULE:
      return { ...state, saving: true, savingScope: 'frequencyRule', saveError: null, saveSuccess: false };
    case SAVE_PIPE_MILL_FREQUENCY_RULE_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        lastSaved: { scope: 'frequencyRule', at: Date.now(), response: action.payload },
        frequencyRules: upsertByKeys(state.frequencyRules, action.payload, ['ruleId', 'id']),
      };
    case SAVE_PIPE_MILL_FREQUENCY_RULE_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to save frequency rule'), saveSuccess: false };
    case DELETE_PIPE_MILL_FREQUENCY_RULE:
      return { ...state, saving: true, savingScope: 'frequencyRuleDelete', saveError: null, saveSuccess: false };
    case DELETE_PIPE_MILL_FREQUENCY_RULE_SUCCESS:
      return {
        ...state,
        saving: false,
        savingScope: null,
        saveSuccess: true,
        frequencyRules: removeByKeys(state.frequencyRules, action.payload, ['ruleId', 'id']),
      };
    case DELETE_PIPE_MILL_FREQUENCY_RULE_FAILURE:
      return { ...state, saving: false, savingScope: null, saveError: errorMessage(action.error, 'Failed to delete frequency rule'), saveSuccess: false };

    case CLEAR_PIPE_MILL_REPORT_SAVE_STATUS:
      return { ...state, saveSuccess: false, saveError: null, savingScope: null };
    case CLEAR_PIPE_MILL_REPORT_ERRORS:
      return {
        ...state,
        reportsError: null,
        mockDataError: null,
        projectLimitsError: null,
        frequencyRulesError: null,
        clearanceStatusError: null,
        saveError: null,
        evaluateError: null,
        metadataErrorByType: {},
      };

    default:
      return state;
  }
}
